<app-header></app-header>
<section id="app" [ngClass]="isDarkMode ? 'dark-mode': ''" class='app'>
    <mat-sidenav-container id="main">
        <mat-sidenav-content>
            <router-outlet></router-outlet>
        </mat-sidenav-content>
        <mat-sidenav position="end" class="player-class">
            <app-player-sidenav></app-player-sidenav>
        </mat-sidenav>
    </mat-sidenav-container>
</section>
<ihm-loading-indicator></ihm-loading-indicator>
